'use client'

import classNames from 'clsx'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import {
  HIGHLIGHT_CARD_COPY,
  HIGHLIGHT_LEAD_ICONS
} from '../fansLandingContent.constants'
import S from '../FansLandingContent.module.scss'

const FansWhyJoinArena = () => {
  const t = useTranslations('fansPage.hero')

  return (
    <>
      <div className={S.redDotBlockIntro}>
        <p className={S.redDotWhyEyebrow}>{t('whyJoinArenaEyebrow')}</p>
        <div className={S.redDotWhyHeadline}>
          <p className={S.redDotWhyHeadlineLine}>
            {t('whyJoinArenaHeadlineLine1')}
          </p>
          <p className={S.redDotWhyHeadlineLine}>
            {t('whyJoinArenaHeadlineLine2')}
          </p>
        </div>
      </div>
      <div className={S.redDotBackdrop}>
        <div className={S.redDotGlowBlob} aria-hidden />
        {HIGHLIGHT_CARD_COPY.map((copy, i) => (
          <div key={copy.titleKey} className={S.joinArenaHighlightCard}>
            <div
              className={classNames(
                S.joinArenaHighlightLeadIcon,
                i > 0 && S.joinArenaHighlightLeadIconLargeGlyph
              )}
              aria-hidden
            >
              <Image
                src={HIGHLIGHT_LEAD_ICONS[i]}
                alt=""
                width={96}
                height={96}
                className={classNames(
                  S.joinArenaHighlightLeadIconImg,
                  i > 0 && S.joinArenaHighlightLeadIconImg2x
                )}
              />
            </div>
            <div className={S.joinArenaHighlightBody}>
              <p className={S.joinArenaHighlightTitle}>{t(copy.titleKey)}</p>
              <p className={S.joinArenaHighlightSubtitle}>{t(copy.bodyKey)}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default FansWhyJoinArena
